export default __webpack_public_path__ + "static/media/icon-drop_down.b8e25ee4.svg";